import { render, staticRenderFns } from "./admin.contents.vue?vue&type=template&id=10e2aab1&"
import script from "./admin.contents.vue?vue&type=script&lang=js&"
export * from "./admin.contents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports